import { useCallback } from "react";
import { Input, Form } from "antd";
import styles from './styles.module.scss'
import {
	Link,
} from "react-router-dom";
import { useDispatch } from "react-redux";
import { authenticate } from "store";
import FormInput from "components/FormInput";
import LoginFormContainer from "../LoginFormContainer";
import CustomButton from "components/Button";
// import { getCookie } from "utils";

const LoginForm = () => {
	const dispatch = useDispatch();
	// const [disableSignIn, setDisableSignIn] = useState<boolean>(false);

	const handleSubmit = useCallback(
		(values: { email: any; password: any }) => {
			dispatch(
				authenticate({
					email: values.email.trim(),
					password: values.password,
				}),
			);
		},
		[dispatch],
	);

	// useEffect(() => {
	// 	// if (getCookie("lockdown")) return setDisableSignIn(true);

	// 	const interval = setInterval(() => {
	// 		if (getCookie("lockdown")) {
	// 			setDisableSignIn(true);
	// 			clearInterval(interval);
	// 		}
	// 	}, 1000);

	// 	return () => {
	// 		clearInterval(interval);
	// 	};
	// }, []);

	return (
		<LoginFormContainer>
			<div className={styles.form}>
				<div
					className={styles.title}
					>
						{"Don't have an account yet? "}
                        <Link
							    className={styles.underlinedTextWithPrimaryColorLink}
								to="/auth/sign-up"
							>
								Sign up
							</Link>
					</div>
					<Form className={styles.form} onFinish={handleSubmit}>
						<div style={{marginBottom:'15px'}}>
						<FormInput
							label="Email"
							name="email"
							rules={[
								{
									type: "email",
									message:
										"Please enter your email address in the format email@example.com!",
									transform: (value) => value?.trim(),
								},
								{
									required: true,
									message: "Please enter your email address!",
								},
							]}
						>
							<Input type="text" placeholder="Enter your email" />
						</FormInput>
					</div>
					<div style={{ marginBottom: "24px" }}>
						<FormInput
							label="Password"
							name="password"
							style={{ marginBottom: "8px" }}
							hasFeedback
							rules={[
								{
									required: true,
									message: "Please input your Password!",
								},
							]}
						>
							<Input.Password placeholder="Enter your password" />
						</FormInput>
                        <div className={styles.forgotLinks}>
							<Link
								className={styles.underlinedTextWithPrimaryColorLink}
								to="/auth/forgot-password"
							>
								Forgot password
							</Link>
						</div>
                        </div>
						<FormInput
							className={styles.formItemCenteredNoMarginBtn}
                            style={{margin:'0px'}}
						>
							<CustomButton
								htmlType="submit"
								buttonText="Sign in"
							/>
						</FormInput>
					</Form>
					</div>
					</LoginFormContainer>
    )
}
export default LoginForm
